<template>
  <div class="implementation">
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>拟开展服务项目<span>*</span></p>
      </div>
    </div>
    <div class="formItemCheckout">
      <div
        class="formItemCheckoutmain"
        v-for="(item, index) in checkList"
        :key="index"
      >
        <el-checkbox v-model="item.checked">{{ item.name }}</el-checkbox>
        <div
          class="formItemCheckoutmainItem"
          v-for="(ite, ind) in item.checkOutList"
          :key="ind"
        >
          <el-checkbox v-model="ite.checked" :disabled="!item.checked">{{
            ite.name
          }}</el-checkbox>
          <el-input
            v-if="ind == item.inpIndex && ite.checked"
            v-model="ite.nameInp"
            placeholder="请输入内容"
          ></el-input>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>目标用户<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-checkbox-group v-model="targetUserList">
          <el-checkbox label="企业"></el-checkbox>
          <el-checkbox label="政府/事业单位"></el-checkbox>
          <el-checkbox label="个人"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>盈利模式<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-checkbox-group v-model="profitModelList">
          <el-checkbox label="前向用户收费"></el-checkbox>
          <el-checkbox label="后向平台服务收费"></el-checkbox>
          <el-checkbox label="混合收费"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>网站或APP情况(至少选择一项) <span>*</span></p>
      </div>
    </div>
    <!--  -->
    <div class="formItemCheckApp">
      <div class="formItemCheckAppmain">
        <div class="appInfomain" v-for="item in appMsgList" :key="item.type">
          <el-checkbox v-model="item.checked">{{ item.name }}</el-checkbox>
          <div class="inputList" v-for="(ite, ind) in item.list" :key="ind">
            <el-input v-model="ite.name" placeholder="请输入内容"></el-input>
            <el-input v-model="ite.domain" placeholder="请输入内容"></el-input>
            <el-input v-model="ite.address" placeholder="请输入内容"></el-input>
            <el-input v-model="ite.company" placeholder="请输入内容"></el-input>
            <span class="el-icon-delete"></span>
          </div>
          <div class="addApp"><i class="el-icon-plus"></i>添加</div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>公司域名证书 <span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList1"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>需专项审批项目</p>
      </div>
      <div class="formItemRightMain">
        <el-checkbox-group v-model="requiringList">
          <el-checkbox label="新闻"></el-checkbox>
          <el-checkbox label="文化"></el-checkbox>
          <el-checkbox label="视听节目"></el-checkbox>
          <el-checkbox label="医药和医疗器械"></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemRightMain" style="marginLeft:108px;marginTop:-25px;">
        <el-upload
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :before-remove="beforeRemove"
          multiple
          :limit="3"
          :on-exceed="handleExceed"
          :file-list="fileList2"
        >
          <el-button size="small" type="primary"
            ><i class="el-icon-upload"></i> 上传文件</el-button
          >
          <div slot="tip" class="el-upload__tip">
            请上传jpg； jpeg； gif格式的文件
          </div>
        </el-upload>
      </div>
    </div>
    <div class="formItemNext">
      <button @click="$router.go(-1)">上一步</button>
      <button @click="$router.push('/icpfillmaterials/personnel')">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //拟开展服务项目
      checkList: [
        {
          name: '信息发布平台和递送服务',
          checked: false,
          inpIndex: 2,
          checkOutList: [
            {
              name: '应用商店',
              checked: false
            },
            {
              name: '门户网站',
              checked: false
            },
            {
              name: '其他',
              checked: false,
              nameInp: ''
            }
          ]
        },
        {
          name: '信息搜索查询服务',
          checked: false,
          inpIndex: 2,
          checkOutList: [
            {
              name: '搜索引擎',
              checked: false
            },
            {
              name: '网页导航',
              checked: false
            },
            {
              name: '其他',
              checked: false,
              nameInp: ''
            }
          ]
        },
        {
          name: '信息即时交互服务',
          checked: false,
          inpIndex: 2,
          checkOutList: [
            {
              name: '即时通讯',
              checked: false
            },
            {
              name: '互联网交互式语音',
              checked: false
            },
            {
              name: '其他',
              checked: false,
              nameInp: ''
            }
          ]
        },
        {
          name: '信息保护和加工处理服务',
          checked: false,
          inpIndex: 2,
          checkOutList: [
            {
              name: '防病毒平台',
              checked: false
            },
            {
              name: '垃圾信息拦截平台',
              checked: false
            },
            {
              name: '其他',
              checked: false,
              nameInp: ''
            }
          ]
        }
      ],
      targetUserList: [],
      profitModelList: [],
      appMsgList: [
        {
          type: 1,
          name: '网站信息',
          checked: false,
          list: [
            {
              name: '',
              domain: '',
              address: '',
              company: ''
            }
          ]
        },
        {
          type: 2,
          name: 'app信息',
          checked: false,
          list: [
            {
              name: '',
              domain: '',
              address: '',
              company: ''
            }
          ]
        }
      ],
      fileList1: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      fileList2: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ],
      requiringList: []
    };
  },
  mounted() {
    this.$store.commit('qffillmaterials/changeActivedIndex', 1);
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>

<style lang="scss">
.implementation {
  width: 100%;
  background: #fff;
  padding: 4px 246px;
  margin-bottom: 60px;
  .applicantInfoFormItem {
    width: 100%;
    display: flex;
    padding: 16px 0;
    .formItemLeftTitle {
      p {
        text-align: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        padding-right: 10px;
        span {
          color: #f00;
          margin-left: 5px;
          line-height: 32px;
        }
      }
    }
    .formItemRightMain {
      flex: 1;
      display: flex;
      align-items: center;
      .el-input {
        width: 435px;
        height: 32px;
        border-radius: 4px;
        input {
          width: 100%;
          height: 100%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 22px;
          padding: 0 12px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
      & > span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-left: 10px;
      }
      .el-button {
        width: 100px;
        height: 32px;
        padding: 0;
        border-radius: 4px;
        border: 1px solid rgba(255, 138, 1, 1);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 138, 1, 1);
        line-height: 22px;
        background: #fff;
      }
      .upload-demo {
        width: 435px;
      }
    }
    .formItemRightBt {
      width: 435px;
      height: 32px;
      display: flex;
      flex: none;
      .el-input {
        flex: 1;
      }
      .el-button {
        width: 73px;
        margin-left: 10px;
      }
    }
  }
  .is-checked {
    .el-checkbox__inner {
      background-color: #fe6a01;
      border-color: #fe6a01;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .el-checkbox__inner:hover {
    border-color: #fe6a01;
  }
  .el-checkbox__label {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    line-height: 18px;
  }
  .formItemCheckout {
    width: 705px;
    margin: 0 auto;
    border-top: 1px solid #e8e8e8;
    .formItemCheckoutmain {
      width: 100%;
      height: 53px;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      & > .el-checkbox {
        width: 236px;
        height: 100%;
        display: flex;
        align-items: center;
        padding-left: 30px;
        .el-checkbox__label {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 18px;
        }
      }
      .is-disabled {
        .el-checkbox__inner:hover {
          border-color: #dcdfe6;
        }
      }
      .formItemCheckoutmainItem {
        display: flex;
        align-items: center;
        .el-input {
          width: 133px;
          height: 30px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          margin-left: 10px;
          input {
            width: 100%;
            height: 100%;
            border: none;
          }
        }
      }
      .formItemCheckoutmainItem:nth-child(2) {
        width: 107px;
      }
      .formItemCheckoutmainItem:nth-child(3) {
        width: 157px;
      }
      .formItemCheckoutmainItem:nth-child(4) {
        width: 184px;
      }
    }
  }
  .formItemCheckApp {
    width: 100%;
    .formItemCheckAppmain {
      width: 100%;
      display: flex;
      flex-direction: column;
      .appInfomain {
        width: 100%;
        display: flex;
        flex-direction: column;
        .el-checkbox {
          margin-bottom: 15px;
        }
        .inputList {
          width: 100%;
          height: 53px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #e8e8e8;
          .el-input {
            width: 154px;
            height: 30px;
            background: rgba(255, 255, 255, 1);
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            margin-left: 10px;
            input {
              width: 100%;
              height: 100%;
              border: none;
            }
          }
          span {
            margin-left: 17px;
            color: #ababab;
            font-size: 16px;
            display: none;
            cursor: pointer;
          }
        }
        .inputList:hover {
          span {
            display: flex;
          }
        }
        .inputList:nth-child(2) {
          border-top: 1px solid #e8e8e8;
        }
        .addApp {
          width: 100%;
          height: 28px;
          border-radius: 2px;
          border: 1px dashed rgba(217, 217, 217, 1);
          margin: 15px 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 21px;
          cursor: pointer;
        }
      }
    }
  }
  .formItemNext {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      border: none;
      margin-right: 20px;
      cursor: pointer;
    }
    button:hover {
      opacity: 0.5;
    }
  }
}
</style>
